import { FC, useState } from "react"
import { Alert, Avatar, Box, CircularProgress, Typography } from "@mui/material"

import {
  InvitedUser,
  useGetEventInvited,
} from "../../../../app/data/promotion/promotionApi"
import { transformDate } from "../../../../shared/transformDate/transformDate"
import { transformNameToNeededLength } from "../../../../shared/transformNameToNeededLength/transformNameToNeededLength"
import SearchPhoneEmployees from "../../SearchPhoneEmployees"
import AvatarFallback from "../../../../assets/svg/header-icons-pack/avatar-empty-icon.svg?react"
import * as s from "./style"

type Props = {
  eventId: number
  promoterId?: number
}

const InvitedPeopleCard: FC<Props> = ({ eventId, promoterId }) => {
  const [query, setQuery] = useState("")
  const [isErrorPopup, setIsErrorPopUp] = useState("")
  const { data, isLoading, isError } = useGetEventInvited({
    phone: query.slice(1).length < 6 ? "" : query.slice(1),
    eventId: eventId,
    promoterId: promoterId,
  })

  const handleSelectPerson = (user: InvitedUser) => {}

  return (
    <>
      <SearchPhoneEmployees
        errorTitle={isErrorPopup}
        serErrorTitle={setIsErrorPopUp}
        query={query}
        setQuery={setQuery}
      />
      <Box
        sx={{
          ...s.contactsContainer,
          justifyItems: isLoading ? "center" : "unset",
          alignContent: isLoading ? "center" : "start",
        }}
      >
        {isError && (
          <Alert severity="error">{`Упс, что то пошло не так....`}</Alert>
        )}

        {!data && isLoading && !isError && <CircularProgress />}

        {data && data.content.length === 0 && !isLoading && !isError && (
          <Alert severity="warning">
            <Typography>Пользователь не найден</Typography>
          </Alert>
        )}

        {data &&
          data.content.length > 0 &&
          !isLoading &&
          !isError &&
          data.content.map((user) => {
            const { firstname, lastname, phone_number, invited, id } = user
            const userName = transformNameToNeededLength(
              firstname,
              lastname,
              19,
            )
            const date = transformDate(invited)

            return (
              <Box
                key={id}
                onClick={() => handleSelectPerson(user)}
                sx={s.contactItem}
              >
                <Avatar alt={userName} src={""} sx={s.contactAvatar}>
                  <AvatarFallback
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                    }}
                  />
                </Avatar>

                <Box sx={s.contactInfo}>
                  <Box sx={s.contactName}>
                    <Typography variant="body1" fontWeight={500}>
                      {userName}
                    </Typography>

                    <Typography variant="body2" fontWeight={300}>
                      {phone_number}
                    </Typography>
                  </Box>
                  <Box sx={s.contactDate}>
                    <Typography
                      variant="caption"
                      color={"var(--unselected-text)"}
                      fontWeight={400}
                    >
                      {date}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )
          })}
      </Box>
    </>
  )
}

export default InvitedPeopleCard
